export enum PaymentFlowEnum {
    CREDIT = 'credit',
    DEBIT = 'debit'
}